import React from "react";
import { Link } from "react-router-dom";
import { chunk } from "lodash";
import { Box, Stack, Cluster, Checkbox, Text } from "@thecb/components";
import { TableRow } from "@/components/generic/Table";
import { TableRowEntry } from "@/components/generic/NewTable";
import { LineItemDescription, LineItemSubDescription } from "./FullLineItem.styled";
import { WHITE, BACKGROUND_GREY } from "@/constants/colors";

const FullLineItem = ({
  lineItem,
  description,
  subDescription,
  previousRefunds,
  isRefunded,
  setIsRefunded,
  goToPayment,
}) => {
  const amountRefundable = lineItem?.amountRefundableInCents?.value ?? 0;
  const refundable = amountRefundable > 0;
  const background = refundable ? WHITE : BACKGROUND_GREY;
  const defaultDescription = `Item ${lineItem.id.value}`;
  const defaultSubDescription = "Not Available";
  const handleCheck = () => {
    setIsRefunded({ lineItem, isRefunded: !isRefunded });
  };

  const formatPreviousRefunds = (refundData) => {
    const refundBoxes = refundData.map((refund, index) => {
      const separator =
        (index + 1) % 3 === 0 || index === refundData.length - 1 ? "" : " | ";

      return (
        <Text
          key={refund.id.value}
          extraStyles={"font-size: 12px; white-space: pre; line-height: 20px;"}
        >
          <Link
            to={`/payment/${refund.id.value}`}
            onClick={() => goToPayment({ transactionId: refund.id.value })}
          >
            {refund.id.value}
          </Link>
          {separator}
        </Text>
      );
    });

    return chunk(refundBoxes, 3).map((refundRow, index) => (
      <Cluster key={index} justify="flex-end" extraStyles={"line-height: 20px;"}>
        {refundRow}
      </Cluster>
    ));
  };

  const displayPreviousRefunds = previousRefunds.length > 0 && (
    <Box padding="0">
      <Stack direction="row" childGap=".5rem">
        <Text extraStyles={"font-size: 12px; line-height: 19px;"}>
          {"Previous refunds: "}
        </Text>
        <Stack justify="flex-start" childGap="0">
          {formatPreviousRefunds(previousRefunds)}
        </Stack>
      </Stack>
    </Box>
  );

  return (
    <TableRow background={background} noHover autoHeight>
      <TableRowEntry padding={"16px"}>
        <Cluster nowrap align="center">
          <Checkbox
            name={`Line Item ${lineItem.id.value}`}
            checked={isRefunded}
            onChange={handleCheck}
            disabled={!refundable}
          />
          <Stack>
            <LineItemDescription>
              {description || defaultDescription}
            </LineItemDescription>
            <LineItemSubDescription>
              {subDescription || defaultSubDescription}
            </LineItemSubDescription>
          </Stack>
        </Cluster>
      </TableRowEntry>
      <TableRowEntry padding={"16px"}>
        <Cluster justify="flex-end" childGap="1rem" align="center">
          <Stack justify="flex-end" align="end" childGap="1px">
            <Text weight="600" extraStyles={"font-size: 14px; text-align: right"}>
              {`$${(amountRefundable / 100).toFixed(2)} refundable`}
            </Text>
            {displayPreviousRefunds}
          </Stack>
        </Cluster>
      </TableRowEntry>
    </TableRow>
  );
};

export default FullLineItem;
